import React from "react";
import PageHeader from "../../components/ui/PageHeader";
import HouseDetails from "../../components/ui/HouseDetails";

const HouseView = () => {

  const propertyData = JSON.parse(localStorage.getItem("property"));

  return (
    <div>
      <PageHeader title={propertyData?.name} text={`Home/ ${propertyData?.propertyUse}/ Properties details`} />
      <HouseDetails />
    </div>
  );
};

export default HouseView;
